import { defineComponent as _defineComponent } from 'vue'

import InfoCircle from '@components/InfoCircle.vue';
import Icon from '@components/Icon.vue';

import { faTriangleExclamation } from '@icons/duotone/faTriangleExclamation';

declare module 'vue/types/vue' {
  export interface Vue {
    TableCellProductSaleNotice: ComponentWithProps;
  }
}

const NOTICE_MESSAGE =
  'Product sale functionality is currently not functional as migration to using Stripe continues.';

const __default__ = { name: 'TableCellProductSaleNotice' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

return { __sfc: true,NOTICE_MESSAGE, InfoCircle, Icon, faTriangleExclamation }
}

})